import { AxiosResponse } from "axios";

import API from "../api";

import type { Country } from "../models/country";

const ROUTE_NAME = "countries";

const CountryService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Country>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Country[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(country: Country): Promise<AxiosResponse<Country>> {
    return await API.post(`/${ROUTE_NAME}`, country);
  },
  async update(id: number, country: Country): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, country);
  },
  async delete(id: number): Promise<AxiosResponse<Country>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default CountryService;
